import { render, staticRenderFns } from "./RequestFileForm.vue?vue&type=template&id=166edc47&scoped=true&"
import script from "./RequestFileForm.vue?vue&type=script&lang=js&"
export * from "./RequestFileForm.vue?vue&type=script&lang=js&"
import style0 from "./RequestFileForm.vue?vue&type=style&index=0&id=166edc47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166edc47",
  null
  
)

export default component.exports